import React, { useState, useContext, useEffect, useCallback } from "react";
import axios from "../../../../axios/index";
// Context
import { UserContext } from "../../../Context/UserContextProvider";
// components
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ConsultantReportsTable from "./ConsultantReportsTable";
// import ConsultantTextReports from './ConsultantTextReports';
import ConsultantReportsExpertReport from "./ConsultantReportsExpertReport";
import ConsultantReportsService from "./ConsultantReportsService";
import { useLocation } from "react-router-dom";
//Styles
import styles from "../DashboardFileManagement.module.css";
//Table : https://getbootstrap.com/docs/4.0/content/tables/
// Re Useable Components
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import ConsultantReportsHeader from "./ConsultantReportsHeader";
import ShowProfileModal from "../CardDetail/ShowProfileModal";

const ConsultantReports = props => {
  const { state } = useLocation();
  const { userToken } = useContext(UserContext);
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [filterConsultantTable, setFilterConsultantTable] = useState({
    filterCalls: false,
    filterShares: false,
    filterExpertReport: true,
    filterService: false,
  });
  const [consultanID, setConsultantID] = useState([2]);
  const [consultans, setConsultans] = useState([]);
  const [bleachersReport, setBleachersReport] = useState([]);
  const [serviceReport, setServiceReport] = useState([]);
  const [callReport, setCallReport] = useState([]);
  const filterBtnHandler = useCallback(event => {
    const { id } = event.target;
    const filters = {
      filterCalls: id === "filterCalls",
      // filterTexts: id === "filterTexts",
      filterExpertReport: id === "filterExpertReport",
      filterService: id === "filterService",
    };
    setFilterConsultantTable(prev => ({ ...prev, ...filters }));
  }, []);
  const fetchData = async () => {
    const getFileConsultantsPromise = axios.get(`Estate/EstateConsultant/${state.detail.id}`, {
      headers: { authorization: "Bearer " + userToken },
    });
    let getBleacherReportsPromise, getServiceReportsPromise, getCallsPromise;
    if (filterConsultantTable.filterExpertReport) {
      getBleacherReportsPromise = axios.get(`ConsultantReport?estateId=${state.detail.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
    }
    if (filterConsultantTable.filterService) {
      getServiceReportsPromise = axios.get(`ConsultantCardService?estateId=${state.detail.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
    }
    if (filterConsultantTable.filterCalls) {
      getCallsPromise = axios.get(`ReportCall?estateId=${state.detail.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
    }
    const [getFileConsultants, getBleacherReports, getServiceReports, getCalls] = await Promise.all([
      getFileConsultantsPromise,
      getBleacherReportsPromise,
      getServiceReportsPromise,
      getCallsPromise,
    ]);
    setConsultans(getFileConsultants.data.data);
    if (getBleacherReports) {
      setBleachersReport(getBleacherReports.data.data);
    } else {
    }
    if (getServiceReports) {
      setServiceReport(getServiceReports.data.data);
    }
    if (getCalls) {
      setCallReport(getCalls.data.data);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, [consultanID, state?.detail?.id, userToken, filterConsultantTable]);
  // const filteredData = useMemo(() => {
  //     // compute filtered data here
  // }, [consultans, bleachersReport, serviceReport, callReport, filterConsultantTable]);
  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />
      {isLoading ? (
        <div className={styles.loader_container}>
          <div className={styles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} />
                <ConsultantReportsHeader
                  id={state?.detail?.id}
                  consultans={consultans}
                  setConsultantID={setConsultantID}
                  consultanID={consultanID}
                  state={state?.detail}
                />
                <div className="w-100 d-flex align-items-center justify-content-center my-3">
                  {/* <div state.state.="filterTexts" className={`d-flex align-items-center justify-content-center mx-4 ${filterConsultantTable.filterTexts ? styles.filter_table_btn_focused : styles.filter_table_btn}`} onClick={filterBtnHandler}>
                                            پیام‌ها
                                        </div> */}
                  <div
                    id="filterCalls"
                    className={`d-flex align-items-center justify-content-center mx-4 ${
                      filterConsultantTable.filterCalls ? styles.filter_table_btn_focused : styles.filter_table_btn
                    }`}
                    onClick={filterBtnHandler}>
                    تماس ها
                  </div>
                  <div
                    id="filterService"
                    className={`d-flex align-items-center justify-content-center mx-4 ${
                      filterConsultantTable.filterService ? styles.filter_table_btn_focused : styles.filter_table_btn
                    }`}
                    onClick={filterBtnHandler}>
                    کارت سرویس
                  </div>
                  <div
                    id="filterExpertReport"
                    className={`d-flex align-items-center justify-content-center mx-4 ${
                      filterConsultantTable.filterExpertReport ? styles.filter_table_btn_focused : styles.filter_table_btn
                    }`}
                    onClick={filterBtnHandler}>
                    گزارش کارشناسی
                  </div>
                </div>
                {filterConsultantTable.filterCalls === true ? (
                  <ConsultantReportsTable id={state?.detail?.id} consultanID={consultanID} callReport={callReport} />
                ) : filterConsultantTable.filterService === true ? (
                  <ConsultantReportsService id={state?.detail?.id} serviceReport={serviceReport} />
                ) : (
                  filterConsultantTable.filterExpertReport === true && (
                    <ConsultantReportsExpertReport id={state?.detail?.id} bleachersReport={bleachersReport} />
                  )
                )}
                {/* : filterConsultantTable.filterTexts === true ? <ConsultantTextReports id={id} /> */}
                <Stack
                  className={styles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <Pagination count={5} variant="outlined" shape="rounded" />
                </Stack>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu manageFiles />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ConsultantReports;
